<template>
   <el-tabs type="border-card">
        <el-tab-pane label="产品编辑">
            <div style="margin-top:16px;" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="产品型号">
                        <el-input v-model.trim="form.manufacturerNumber" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="产品库存">
                        <el-input v-model.trim="form.stockCount" placeholder="产品库存"></el-input>
                    </el-form-item>
                    <el-form-item label="库存类型">
                        <el-select v-model.trim="form.stockState" placeholder="库存类型">
                          <el-option label="国外" value="0" disabled></el-option>
                          <el-option label="国内" value="8" disabled></el-option>
                          <el-option label="自营" value="2" disabled></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品价格" >
                          <div style="height:40px;line-height:40px;cursor: pointer;"  @click="addPriceClick">
                            <i class="el-icon-circle-plus" style="font-size:18px;margin-right:5px"></i>添加价格
                          </div>
                        <div v-for="(item,index) in this.form.segmentPriceList" :key="index" style="margin-top:10px">
                            <el-input v-model.trim="item.count" style="width:80px;"></el-input>
                            <el-input v-model.trim="item.price" style="width:220px;"></el-input>
                            <el-button type="danger" @click="deletePriceClick(index)">删除</el-button>
                        </div>
                      
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即编辑</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
  export default {
    data() {
      return {
        display: false,
        form: {
          id: '',
          platformId: '',
          productNumber: '',
          manufacturerNumber: '',
          stockCount: '',
          stockState: '',
          segmentPrice: '',
          segmentPriceList: [],
          token: this.user.getToken()
        },
        segmentPriceList: []
      }
    },

    methods: {
      addPriceClick(){
          this.form111.segmentPriceList.push({price:'',count:''})
      },
      deletePriceClick(index){
           
          this.$confirm('此操作删除价格'+this.form.segmentPriceList[index].price+', 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.form.segmentPriceList.splice(index,1)
             
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
      },
      onSubmit() {
        // 初始化默认加载菜单
        console.log(JSON.stringify(this.form))
        //校验输入的数据
        let validateRes = false
        let isIntNumber= /(^[1-9]\d*$)/
        let isDoubleNumber= /\d+(\.\d+)?/
        for(let i=0; i<this.form.segmentPriceList.length;i++){
            if(!isIntNumber.test(this.form.segmentPriceList[i].count)||!isDoubleNumber.test(this.form.segmentPriceList[i].price)){
              this.$message({
                type: 'info',
                message: '请填入正确的参数'
              })
              validateRes = false
              break;
            } else {
              validateRes = true
            }
         }
         this.form.segmentPrice = JSON.stringify(this.form.segmentPriceList)
        if(validateRes){
          this.http.post(
            '/product/editor', 
            this.form, res => {
              if (res.success) {
                // 返回正确的处理
                this.$router.push("/product/list")
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }
        
      },
      onCancel() {
          this.$router.go(-1)
      }
    },
    mounted() {
      this.form.id = this.$route.params.id
      this.form.platfromId = this.$route.params.platfromId
      this.form.manufacturerNumber = this.$route.params.manufacturerNumber
      this.form.productNumber = this.$route.params.productNumber
      this.form.stockCount = this.$route.params.stockCount
      this.form.segmentPrice = this.$route.params.segmentPrice
      this.form.stockState = this.$route.params.stockState + ''
      if (this.$route.params.segmentPrice != null) {
       this.form.segmentPriceList = eval('(' + this.$route.params.segmentPrice + ')')
      }else {
        this.form.segmentPriceList = []
      }
      this.display = false
    }
  }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/product/productEditor.vue